import { StringHelper } from "../../../../../helper";
import _ from "lodash";

const hashDepartment = (data: any[], hashField: string) => {
  let result: any = {};
  for (let item of data) {
    const fieldData = item[hashField];
    if (result?.[fieldData]) {
      result[fieldData] = result[fieldData].concat(item.eTrainingCourses);
    } else {
      result[fieldData] = item.eTrainingCourses;
    }
  }
  return result;
};
const hashData = (data: any[], field: string) => {
  let result: any = {};
  data.forEach((item) => {
    const fieldData = item[field];
    if (result?.[fieldData]) {
      result[fieldData] = [...result[fieldData], item];
    } else {
      result[fieldData] = [item];
    }
  });
  return result;
};

export const transform = (requests: any[] = []): any[] => {
  let output = [];

  const hashedDepartment = hashDepartment(requests, "eDepartment");
  for (let eDepartment in hashedDepartment) {
    const trainingCourses = hashedDepartment[eDepartment];
    const hashedTrainingCourse = hashData(trainingCourses, "eTrainingCourse");
    for (let eTrainingCourse in hashedTrainingCourse) {
      const hashedMajor = hashData(
        hashedTrainingCourse[eTrainingCourse],
        "eMajor"
      );
      for (let eMajor in hashedMajor) {
        const eSubjects = hashedMajor[eMajor];
        output.push({ eDepartment, eTrainingCourse, eMajor, eSubjects });
      }
    }
  }

  return _.chain(output)
    .groupBy("eDepartment")
    .map((value, key) => {
      const result1 = _.chain(value)
        .groupBy("eTrainingCourse")
        .map((value, key) => {
          const result2 = _.chain(value)
            .groupBy("eMajor")
            .map((value, key) => {
              return {
                key: StringHelper.random(),
                eTitle: key,
                children: value[0].eSubjects.map(
                  (item: any, index: number) => ({
                    ...item,
                    stt: index + 1,
                    eTrainees: item?.eTrainees
                      ?.map((item: any) => `${item.label}(${item.value})`)
                      ?.join(","),
                    eTrainingCount: item?.eTrainees?.reduce(
                      (count: number, current: any) => (count += current.value),
                      0
                    ),
                    eCoursePlaces: item?.eCoursePlaces
                      ?.map((item: any) => `${item.label}(${item.value})`)
                      ?.join(","),
                    eLessonTypes: item?.eLessonTypes
                      ?.map((item: any) => `${item.label}(${item.value})`)
                      ?.join(","),
                  })
                ),
              };
            })
            .map((value, index) => ({
              ...value,
              eTitle: value.eTitle,
              // eTitle: `${index + 1}. ${value.eTitle}`,
            }));
          return {
            key: StringHelper.random(),
            eTitle: key,
            children: result2.value(),
          };
        })
        .map((value, index) => ({
          ...value,
          eTitle: value.eTitle,
          // eTitle: `${StringHelper.intToRoman(index + 1)}. ${value.eTitle}`,
        }));
      return {
        key: StringHelper.random(),
        eTitle: key,
        children: result1.value(),
      };
    })
    .map((value, index) => ({
      ...value,
      eTitle: value.eTitle,
      // eTitle: `${String.fromCharCode(65 + index)}. ${
      //   StringHelper.verticalBarSplit<string[]>(value.eTitle)[1]
      // }`,
    }))
    .value();
};
